if (!customElements.get('diy-trust-reviews')) customElements.define('diy-trust-reviews', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.list = this.querySelector('.diy-trust__list');
    this.previous = this.querySelector('[data-trust-prev]');
    this.next = this.querySelector('[data-trust-next]');
    this.onPrevious = () => this.move(-1);
    this.onNext = () => this.move(1);
    this.onScroll = () => this.updateButtons();
    this.previous.hidden = this.next.hidden = false;
    this.previous.addEventListener('click', this.onPrevious);
    this.next.addEventListener('click', this.onNext);
    this.list.addEventListener('scroll', this.onScroll, { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.updateButtons());
    this.resizeObserver.observe(this.list);
    this.initialized = true;
    this.updateButtons();
    // Also handles Shopify section re-rendering after the async bootstrap has loaded.
    const widget = this.querySelector('.trustpilot-widget');
    if (widget && !widget.querySelector('iframe') && window.Trustpilot?.loadFromElement) {
      window.Trustpilot.loadFromElement(widget, true);
    }
  }
  disconnectedCallback() {
    this.previous?.removeEventListener('click', this.onPrevious);
    this.next?.removeEventListener('click', this.onNext);
    this.list?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
    this.initialized = false;
  }
  move(direction) {
    const card = this.list.querySelector('.diy-trust__review');
    const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    this.list.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
  }
  updateButtons() {
    const maximum = this.list.scrollWidth - this.list.clientWidth;
    this.previous.disabled = this.list.scrollLeft <= 2;
    this.next.disabled = this.list.scrollLeft >= maximum - 2;
  }
});
